module.exports = __webpack_public_path__ + "0c4df27f0e0ee1c0317e2efc75e22c17.png";